<template>
    <div class="pp-content">
        <div @click="$root.mobileBack()" v-if="$root.view == 'mobile'" class="pp-mobile-back pp-mobile-back--light">
            <i class="fa fa-fw fa-angle-left"></i>
        </div>
        <div class="pp-header pp-header--simple pp-header--image-composers pp-header--mobile-small">
            <div class="pp-header__title">
                All Composers
            </div>
        </div>
        <div class="pp-content__page">
            <div class="pp-tabs">
                <ul ref="headers" class="pp-tabs__headers">
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse">
                            Popular
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/albums">
                            Albums
                        </router-link>
                    </li>
                    <li v-if="$root.view != 'mobile'" class="pp-tabs__headers__header">
                        <router-link to="/browse/tracks">
                            Tracks
                        </router-link>
                    </li>
                    <li v-if="$root.view == 'mobile'" class="pp-tabs__headers__header">
                        <router-link to="/browse/new">
                            New
                        </router-link>
                    </li>
                    <li ref="headerActive" class="pp-tabs__headers__header pp-tabs__headers__header--active">
                        <router-link to="/browse/composers">
                            Composers
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/ensembles">
                            Ensembles
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/artists">
                            Artists
                        </router-link>
                    </li>
                    <li class="pp-tabs__headers__header">
                        <router-link to="/browse/exclusive">
                            Exclusives
                        </router-link>
                    </li>
                    <li v-if="$root.view == 'mobile'" class="pp-tabs__headers__header">
                        <router-link to="/browse/tracks">
                            Tracks
                        </router-link>
                    </li>
                </ul>
                <div class="pp-tabs__content">
                    <loading-indicator v-if="loading"></loading-indicator>
                    <artist-grid v-if="composers.length > 0"
                                 :items="composers"
                                 link-to="/browse/composers/{id}"
                                 :reachedEnd="reachedEnd"
                                 @paginate="loadMore"
                                 :can-paginate="true"></artist-grid>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import ArtistGrid from '../components/ArtistGrid.vue';
import LoadingIndicator from '../components/LoadingIndicator.vue';
import { api } from '../API.js';

export default {
    name: 'browseComposers',
    components: {
        ArtistGrid,
        LoadingIndicator
    },
    watch: {
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.repositionHeader();
            this.loading = true;

            console.log('fetchData');
            this.page = 1;
            this.paginating = false;
            this.load();
        },
        repositionHeader() {
            this.$refs.headers.scrollLeft = this.$refs.headerActive.offsetLeft -
                                            (this.$refs.headers.clientWidth / 2) +
                                            (this.$refs.headerActive.clientWidth / 2);
        },
        loadMore() {
            if (this.paginating) { return; }

            this.page++;
            this.paginating = true;
            this.load(true);
        },
        load() {
            api.get('/composers', [], {
                limit: 100,
                page: this.page
            }, (data) => {
                if (this.paginating) {
                    if (data.composers.length == 0) {
                        this.reachedEnd = true;
                    } else {
                        for (var item of data.composers) {
                            this.composers.push(item);
                        }
                    }
                } else {
                    this.composers = data.composers;
                    this.loading = false;
                    this.repositionHeader();
                }
                console.log(this);
                setTimeout(() => {
                    this.paginating = false;
                }, 250);
            }, () => {
                console.log('Error!');
            });
        }
    },
    mounted() {
            this.fetchData();
    },
    data() {
        return {
            loading: true,
            composers: [],
            page: 1,
            reachedEnd: false,
            paginating: false
        };
    },

}
</script>



// WEBPACK FOOTER //
// BrowseComposers.vue?110e6c4c